import { MatxLoadable } from "matx";

const PayrollHome = MatxLoadable({
  loader: () => import("./PayRollHome"),
});

const PaylistDetails = MatxLoadable({
  loader: () => import("./Paylist"),
});

const Cafeteria = MatxLoadable({
  loader: () => import("./Cafeteria"),
});

const CafeteriaDetails = MatxLoadable({
  loader: () => import("./CafeteriaDetails"),
});

const Bonus = MatxLoadable({
  loader: () => import("./Bonus"),
});

const PayrollRoutes = [
  {
    path: "/payroll/home",
    component: PayrollHome,
  },
  {
    path: "/payroll/payslip",
    component: PaylistDetails,
  },
  {
    path: "/payroll/cafeteria",
    component: Cafeteria,
  },
  {
    path: "/payroll/cafeteriaDetails/:invoiceNumber",
    component: CafeteriaDetails,
  },
  {
    path: "/payroll/bonos",
    component: Bonus,
  },
];

export default PayrollRoutes;
